module.exports = __webpack_public_path__ + "static/013_Gippsland-56a907b203aa0d43ad8a04db6cfa563e.jpg";